class ConnectForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }

  async handleSubmit(event) {
    event.preventDefault();
    
    const formData = new FormData(this.form);
    const submitButton = this.form.querySelector('button[type="submit"]');
    const originalButtonText = submitButton ? submitButton.textContent : '';
    
    // Disable submit button
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = 'Sending...';
    }

    try {
      const response = await fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (response.ok) {
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Check for success/error indicators using native Shopify form classes
        const successMessage = doc.querySelector('.form-status.form-status-list.form__message, h2.form-status.form-status-list');
        const errorHeading = doc.querySelector('.form-status[role="alert"], h2.form-status[role="alert"]');
        const errorList = doc.querySelector('.form-status-list[role="list"]');
        
        if (successMessage && !errorHeading) {
          // Show success message - replace entire form content
          this.innerHTML = successMessage.outerHTML;
        } else if (errorHeading || errorList) {
          // Show error - replace with error message and form
          const errorContainer = document.createElement('div');
          if (errorHeading) {
            const errorDiv = doc.querySelector('.form__message') || document.createElement('div');
            errorDiv.className = 'form__message';
            if (errorHeading.parentElement === errorDiv || errorHeading.closest('.form__message')) {
              errorContainer.appendChild(errorDiv.cloneNode(true));
            } else {
              errorContainer.appendChild(errorHeading.cloneNode(true));
            }
          }
          if (errorList) {
            errorContainer.appendChild(errorList.cloneNode(true));
          }
          
          // Get the form from response to keep it
          const responseForm = doc.querySelector(`form[id*="${this.form.id.split('-').pop()}"]`) || doc.querySelector('form[id*="ConnectForm"]');
          if (responseForm) {
            this.innerHTML = '';
            this.appendChild(errorContainer);
            this.appendChild(responseForm.cloneNode(true));
            this.form = this.querySelector('form');
            if (this.form) {
              this.form.addEventListener('submit', this.handleSubmit.bind(this));
            }
          } else {
            this.innerHTML = errorContainer.innerHTML;
          }
          
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalButtonText;
          }
        } else {
          // Try to find form in response to update
          const responseForm = doc.querySelector(`form[id*="${this.form.id.split('-').pop()}"]`) || doc.querySelector('form[id*="ConnectForm"]');
          if (responseForm) {
            // Check if form has success/error messages
            const formSuccess = responseForm.querySelector('.form-status.form-status-list.form__message');
            const formError = responseForm.querySelector('.form-status[role="alert"]');
            
            if (formSuccess) {
              this.innerHTML = formSuccess.outerHTML;
            } else if (formError) {
              // Keep form and show errors
              const errorContainer = responseForm.querySelector('.form__message, .form-status-list').parentElement || responseForm;
              this.innerHTML = errorContainer.innerHTML;
              this.form = this.querySelector('form');
              if (this.form) {
                this.form.addEventListener('submit', this.handleSubmit.bind(this));
              }
              if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
              }
            } else {
              // Just update the form
              this.innerHTML = responseForm.outerHTML;
              this.form = this.querySelector('form');
              if (this.form) {
                this.form.addEventListener('submit', this.handleSubmit.bind(this));
              }
            }
          } else {
            // No form found - check if page has success message
            const pageSuccess = doc.querySelector('.form-status.form-status-list.form__message');
            if (pageSuccess) {
              this.innerHTML = pageSuccess.outerHTML;
            } else {
              // Assume success if we got here without errors
              this.showSuccessMessage();
            }
          }
        }
      } else {
        throw new Error('Form submission failed');
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalButtonText;
      }
      this.showErrorMessage('An error occurred. Please try again.');
    }
  }

  showSuccessMessage() {
    // Create success message matching native Shopify form structure
    const successHeading = document.createElement('h2');
    successHeading.className = 'form-status form-status-list form__message';
    successHeading.setAttribute('tabindex', '-1');
    successHeading.setAttribute('autofocus', '');
    
    // Try to get success icon from page or create SVG wrapper
    const iconSuccess = document.querySelector('.icon-success');
    if (iconSuccess) {
      successHeading.appendChild(iconSuccess.cloneNode(true));
    }
    
    // Get success message - check if Spanish or English
    const htmlLang = document.documentElement.lang || '';
    const isSpanish = htmlLang.includes('es') || htmlLang.includes('ES');
    const successText = isSpanish 
      ? 'Gracias por contactarnos. Te responderemos lo antes posible.'
      : 'Thanks for contacting us. We\'ll get back to you as soon as possible.';
    successHeading.appendChild(document.createTextNode(' ' + successText));
    
    this.innerHTML = '';
    this.appendChild(successHeading);
  }

  showErrorMessage(message) {
    // Create error message matching native Shopify form structure
    const errorContainer = document.createElement('div');
    errorContainer.className = 'form__message';
    
    const errorHeading = document.createElement('h2');
    errorHeading.className = 'form-status caption-large text-body';
    errorHeading.setAttribute('role', 'alert');
    errorHeading.setAttribute('tabindex', '-1');
    errorHeading.setAttribute('autofocus', '');
    
    // Try to get error icon from page
    const iconError = document.querySelector('.icon-error');
    if (iconError) {
      errorHeading.appendChild(iconError.cloneNode(true));
    }
    
    errorHeading.appendChild(document.createTextNode(' ' + message));
    errorContainer.appendChild(errorHeading);
    
    // Insert before form if it exists, otherwise append
    if (this.form) {
      this.insertBefore(errorContainer, this.form);
    } else {
      this.appendChild(errorContainer);
    }
  }
}

customElements.define('connect-form', ConnectForm);
